import {FormControl, FormLabel, TextField} from '@mui/material'
import {ChangeEvent, useEffect, useState} from 'react'

interface CustomTextFieldProps {
  label: string
  id?: string
  filter: Record<string, any>
  setFilter?: (value: Record<string, any>) => void
  onEnter?: () => void
  compact?: boolean
}

export const CustomTextField = ({
  label,
  filter,
  id = 'error',
  setFilter,
  onEnter,
  compact = false,
}: CustomTextFieldProps) => {
  const formControlWidthHandler = (id: string) => {
    switch (id) {
      case 'searchData':
        return 'xl:w-[60rem]'
      case 'searchKeyword':
        return 'xl:w-[40rem]'
      case 'managerName':
      case 'installerName':
        return 'md:w-40'
      default:
        return 'md:w-80'
    }
  }

  const [value, setValue] = useState(filter?.[id] || '')

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setValue(filter?.[id] || '')
  }, [filter?.[id]])

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setFilter?.((prev: any) => ({
      ...prev,
      [id]: value,
    }))
  }, [value])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  return (
    <FormControl className={`w-full ${formControlWidthHandler(id)}`} id={id}>
      <FormLabel sx={{fontSize: compact ? '0.875rem' : '1rem', marginBottom: '0.25rem'}}>
        {label}
      </FormLabel>
      <TextField
        id={id}
        variant='outlined'
        size='small'
        autoComplete='off'
        value={value}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onEnter?.()
          }
        }}
        sx={{
          '& .MuiInputBase-root': {
            fontSize: compact ? '1.125rem' : '1.75rem',
            height: compact ? '2.75rem' : '3.5rem',
            backgroundColor: 'white',
          },
          '& input': {
            padding: compact ? '0.5rem' : '0.5rem',
          },
        }}
      />
    </FormControl>
  )
}
